import { render } from "./ItemDeModelo.vue?vue&type=template&id=397f454e&scoped=true&ts=true"
import script from "./ItemDeModelo.vue?vue&type=script&lang=ts"
export * from "./ItemDeModelo.vue?vue&type=script&lang=ts"

import "./ItemDeModelo.vue?vue&type=style&index=0&id=397f454e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397f454e"]])

export default __exports__